// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".process-content .file-style {\n  margin-top: 0px;\n  width: 250px;\n  height: 28px;\n  background: linear-gradient(135deg, #f7faff, #ffffff);\n  border-radius: 2px;\n  display: inline-block;\n}\n.process-content .file-name {\n  width: 50%;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
module.exports = exports;
